import axios, { AxiosError } from 'axios'

// Same-origin in prod (Caddy at /api/*), proxied in dev (vite.config.ts).
const API_BASE = import.meta.env.BASE_URL.replace(/\/$/, '') + '/api'

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

export interface UserOut {
  id: string
  username: string
}

export interface KeysOut {
  apify_token_set: boolean
  openai_set: boolean
  cohere_set: boolean
  anthropic_set: boolean
  apify_last4: string
  openai_last4: string
  cohere_last4: string
  anthropic_last4: string
}

export interface FacetsOut {
  location: string[]
  current_role: string[]
  career_signals: string[]
  industry: string[]
  company_stage: string[]
  company_keywords: string[]
  skills: string[]
  expanded_queries: string[]
  exclude: string[]
  raw_query: string
}

export interface RankedRowOut {
  profile_id: number
  full_name: string
  current_title: string
  current_company: string
  location: string
  linkedin_url: string
  score: number
  reason: string
  debug?: Record<string, unknown> | null
}

export interface RankResponse {
  rows: RankedRowOut[]
  facets: FacetsOut
  search_id?: number | null
}

export interface SearchSummary {
  id: number
  query_text: string
  row_count: number
  created_at: string
  mode: string
  smart_query: boolean
}

export interface SearchDetail extends SearchSummary {
  facets: FacetsOut
  rows: RankedRowOut[]
}

export interface StatusOut {
  total_connections: number
  enriched: number
  pending: number
  missing: number
  failed: number
  embedded: number
  last_enriched_at: string | null
  company_total: number
  company_enriched: number
}

export interface MeProfileOut {
  linkedin_url: string
  full_name: string
  headline: string
  current_title: string
  current_company: string
  about: string
  location: string
  enriched_at: string
}

export interface MeOut {
  preferences: string
  profile: MeProfileOut
  has_profile: boolean
}

export interface FeedbackEntry {
  profile_id: number
  vote: number
}

export interface DraftOut {
  target_name: string
  target_url: string
  message: string
}

export function apiErrorMessage(err: unknown): string {
  if (err instanceof AxiosError) {
    const detail = err.response?.data?.detail
    if (typeof detail === 'string') return detail
    if (err.message) return err.message
  }
  return 'Unexpected error'
}
